import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';
import type { SearchType } from '#/modules/search/types/SearchType';

import { makeSearchLabel } from './makeSearchLabel';
import {
  QueryFieldButton,
  QueryFieldText,
} from './MobileSearchQueryField.styled';

type Props = {
  query?: string;
  searchLocation?: SearchLocation;
  searchType: SearchType;
  radius?: string;
  showSearchContext: boolean;
  onClick: () => void;
};

export function MobileSearchQueryField({
  query,
  searchLocation,
  searchType,
  radius,
  showSearchContext,
  onClick,
}: Props) {
  const { i18n, locale } = useI18n();

  const { label, isPlaceholder } = makeSearchLabel(i18n, locale, searchType, {
    query,
    location: searchLocation,
    radius,
    showSearchContext,
  });

  return (
    <QueryFieldButton
      type="button"
      data-qa-id="mobile-search-pill"
      onClick={onClick}
    >
      <Icon
        name="search"
        size={16}
        colorName="mediumContentGrey"
        aria-hidden={true}
      />
      <QueryFieldText
        data-is-placeholder={isPlaceholder}
        data-qa-id={
          isPlaceholder ? 'search-query-placeholder' : 'search-query-value'
        }
      >
        {label}
      </QueryFieldText>
    </QueryFieldButton>
  );
}
